import { AppTileGridSkeleton, AppTilesGridContainer, AppTileSize } from '@atlassian/mpac-app-tile';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { SectionWrapper } from '../../HomepageCommon.styles';
import { TEST_IDS } from '../../testids';
import { ProminentSectionInfoSkeleton } from '../ProminentSection';
import { RegularSectionSkeleton } from '../RegularSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SectionsSkeleton = () => {
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  const prominentTileCount = isMobile ? 3 : 5;
  const regularTileCount = isTablet ? 4 : 3;
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": TEST_IDS.SECTIONS_SKELETON,
    children: [/*#__PURE__*/_jsx(SectionWrapper, {
      children: /*#__PURE__*/_jsx(RegularSectionSkeleton, {
        hideDescription: true,
        children: /*#__PURE__*/_jsxs(AppTilesGridContainer, {
          children: [/*#__PURE__*/_jsx(ProminentSectionInfoSkeleton, {}), /*#__PURE__*/_jsx(AppTileGridSkeleton, {
            tileCount: prominentTileCount
          })]
        })
      })
    }), /*#__PURE__*/_jsx(SectionWrapper, {
      children: /*#__PURE__*/_jsx(RegularSectionSkeleton, {
        children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
          children: /*#__PURE__*/_jsx(AppTileGridSkeleton, {
            size: AppTileSize.MEDIUM,
            tileCount: regularTileCount
          })
        })
      })
    }), /*#__PURE__*/_jsx(SectionWrapper, {
      children: /*#__PURE__*/_jsx(RegularSectionSkeleton, {
        children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
          children: /*#__PURE__*/_jsx(AppTileGridSkeleton, {
            size: AppTileSize.MEDIUM,
            tileCount: regularTileCount
          })
        })
      })
    })]
  });
};